import React, { useEffect, useState } from 'react'
import Sidebar from '../../_Components/Sidebar';
import httpStatus from 'http-status'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ContainerFluid from '../../../../_layouts/ContainerFluid/Container';

import { history } from '../../../../_helpers/history';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useParams } from 'react-router-dom';
import { alertActions } from '../../../../_actions/alert.actions';
import { doctorService } from '../../../../_services/doctor.service';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Button, Spinner } from 'react-bootstrap'

export default function LandingEditBio() {
  const dispatch = useDispatch();

  const { id } = useParams()
  const [bio, setBio] = useState('')
  const [loading, setLoading] = useState(true);
  const [licensed, setLicensed] = useState({});
  const [updating, setUpdating] = useState(false)

  const client = useSelector(state => state.client)

  useEffect(() => {
    if (!id) {
      history.goBack()
      dispatch(alertActions.error('An error occured and we could not retrieve this landing page at this time.'));
    } else {
      doctorService.getLandingById(id)
        .then(licensed => {
          setBio(licensed.content)
          setLicensed(licensed)
          setLoading(false)
        })
        .catch(() => {
          history.push(`/account/users/${licensed.userId}/landing`)
          dispatch(alertActions.error('An error occured and we could not retrieve this landing page at this time.'));
        })
    }
  }, [client, dispatch, id, licensed.userId]);

  const handleSaveBio = () => {
    setUpdating(true);

    doctorService.updateLandingById(id, bio)
      .then(data => {
        setUpdating(false);

        history.push(`/account/users/${licensed.userId}/landing`)
        dispatch(alertActions.success('Landing Page Updated!'))
      })
      .catch(error => {
        setUpdating(false);

        if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
          dispatch(alertActions.error('Please enter a bio'));
        } else if (error.response && error.response.status === httpStatus.BAD_REQUEST) {
          history.push(`/account/users/${licensed.userId}/landing`)
        } else {
          dispatch(alertActions.error('We could not update this landing page at this time. Please try again.'));
        }
      });
  }

  return <ContainerFluid>
    <Row>
      <Col xs='2'>
        {loading ?
          <Spinner animation='border' />
          :
          <Sidebar client={client} licensed={licensed} />
        }
      </Col>
      <Col >
        <Card>
          <Card.Body>
            <h4 className="font-weight-bold">Edit Biography</h4>
            <Row>
              <Col xs='5'>
                <div className='mb-2 font-weight-bold'>&nbsp;</div>
                <div style={{ height: '400px', overflow: 'scroll' }}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={bio}
                    config={{
                      toolbar: ['heading', '|', 'bold', 'bulletedList'],
                      heading: {
                        options: [
                          { model: 'heading4', view: 'h5', title: 'Title', class: 'ck-heading_heading5' },
                          { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        ]
                      }
                    }}
                    onReady={editor => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "360px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                      document.getElementById('bio-preview').innerHTML = bio
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();

                      setBio(data);

                      document.getElementById('bio-preview').innerHTML = data
                    }}
                  />
                </div>
                <Row className='justify-content-end mt-4'>
                  <Col>
                    <Button disabled={updating} block variant='outline-primary' onClick={() => history.push(`/account/users/${licensed.userId}/landing`)}>Cancel</Button>
                  </Col>
                  <Col>
                    <Button disabled={updating} block variant='success' onClick={handleSaveBio}>Save Bio</Button>
                  </Col>
                </Row>
              </Col>
              <Col>
                <div className='mb-2 font-weight-bold'>Preview:</div>
                <Card >
                  <Card.Body style={{ height: '25em', overflow: 'scroll' }}>
                    <div id='bio-preview'></div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </ContainerFluid>
}


